import {ConfEnv} from "@/config/config";
import privateRequest from "@/Infra/http/private.request";

/**
 * POST orphan-claims (Ubii pago self-service claim).
 * En backend: /v1/user/pago-movil/orphan-claims
 */
export const claimUbiiPagoOrphanService = async payload => {
  return privateRequest.post(`${ConfEnv.API_WALLET.URL_PAGO_MOVIL_ORPHAN_CLAIMS}`, payload);
};

